<template lang="html">
    <div class="client-settings__card">
        <h2 class="header-2">
            Disponibilitate
        </h2>
        
        <FormUpdateTimetable  
            @activeButton="activeNextStep = $event"
        />

        <UiButton
            class="nexyo-button"
            :name="$store.state.settings.steps[5].isLoading ? 'Procesare..' : 'Actualizează'"
            @click="sendUpdateTimetable"
            :disabled="!activeNextStep" 
        />
    </div>
</template>

<script>
import UiButton from '@/components/ui/Button'
import { mapActions, mapGetters } from 'vuex'
import FormUpdateTimetable from '@/components/forms/Settings/Timetable'
export default {
    components: {
        UiButton,
        FormUpdateTimetable
    },
    data() {
        return {
            activeNextStep: false,
            queueChannel: null
        };
    },
    computed: {
        ...mapGetters({
            timetable: 'settings/sixthStep',
            user: 'user/user'
        })
    },
    methods: {
        ...mapActions({
            updateTimetable: 'settings/updateTimetable'
        }),
        sendUpdateTimetable() {
            console.log(this.timetable.timetable);
            this.updateTimetable();
            
            // if(this.activeNextStep) {
                
            //     if( this.timetable.anytimeServices == false ) {
            //         // Send event to WS to disable anytime meetings for the specialist's queue channel
            //         this.queueChannel = this.user.id + '_' + (this.user.full_name).replace(/\s/g, '','') + '_queue';
                                        
            //         this.$socket.emit('anytime_specialist', {
            //             event: 'unavailable', 
            //             queue_channel: this.queueChannel,
            //             specialist_id: this.user.id,
            //             specialist_name: this.user.full_name,
            //             password: 'NeXyo2020-top'
            //         });
            //     }                
            //     this.$store.state.settings.steps[5].isLoading = true;
            //     this.updateTimetable();
            // }
        }
    }
}
</script>

<style lang="css" scoped>
</style>